// queries/panoramas/list-panoramas.ts

export type PanoramaPoint = {
	id: string;
	lat: number;
	lon: number;
	alt: number;
	sceneName: string;
	assetId: string;
};

export type PanoramaListResponse = {
	panoramas: PanoramaPoint[];
	total: number;
};

const MOCK_PANOS: PanoramaPoint[] = [
	{
		id: '018',
		lat: 49.631392,
		lon: 8.380093,
		alt: 155.92,
		sceneName: 'scene_26_09_2022_kasten__018',
		assetId: 'beb8984c-4a11-46c7-995a-c4b722fe8310',
	},
	{
		id: '019',
		lat: 49.631405,
		lon: 8.380168,
		alt: 156,
		sceneName: 'scene_26_09_2022_kasten__019',
		assetId: 'beb8984c-4a11-46c7-995a-c4b722fe8310',
	},
	{
		id: '020',
		lat: 49.63142,
		lon: 8.380251,
		alt: 155.91,
		sceneName: 'scene_26_09_2022_kasten__020',
		assetId: 'beb8984c-4a11-46c7-995a-c4b722fe8310',
	},
	{
		id: '041',
		lat: 49.63144,
		lon: 8.380361,
		alt: 156.07,
		sceneName: 'scene_26_09_2022_kasten__041',
		assetId: 'beb8984c-4a11-46c7-995a-c4b722fe8310',
	},
];

export async function getPanoramasByAssetId(assetId: string): Promise<PanoramaListResponse> {
	// simulate API delay
	await new Promise((resolve) => setTimeout(resolve, 300));

	const filtered = MOCK_PANOS.filter((p) => p.assetId === assetId);

	return {
		panoramas: filtered,
		total: filtered.length,
	};
}
